module.exports = __webpack_public_path__ + "img/A58A1064.82f26e0f.jpg";